import clsx from "clsx";

import { sortProductSizes } from "../../utils/sortProductSizes";

interface Props {
  sizes: { text: string; enabled: boolean }[];
}

export const SizeOptions = ({ sizes }: Props): React.ReactNode => {
  const logSizes = sortProductSizes(sizes.map(({ text }) => text));
  console.log("%c logSizes", "color: blue;", logSizes);
  return (
    sizes.length > 0 && (
      <div className="hidden flex-row flex-wrap gap-1 sm:flex">
        {sortProductSizes(sizes.map(({ text }) => text)).map((sizeText) => {
          const { enabled } = sizes.find((size) => size.text === sizeText)!;
          return (
            <div
              key={sizeText}
              className={clsx(
                "h-fit items-center justify-center rounded-lg border-2 border-base-input",
                "px-1 py-0.5 text-neutral-text",
                { "opacity-50": !enabled },
              )}
            >
              {sizeText}
            </div>
          );
        })}
      </div>
    )
  );
};
